// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3dpvP","inner":"Form_inner__HIoid","range":"Form_range__3XeQh","name":"Form_name__1iuyS","actions":"Form_actions__1-SFO"};